export default __webpack_public_path__ + "static/media/nexFortris.5766c9f7.png";